import { render, staticRenderFns } from "./AddAnonymous.vue?vue&type=template&id=2be6c299&scoped=true"
import script from "./AddAnonymous.vue?vue&type=script&lang=js"
export * from "./AddAnonymous.vue?vue&type=script&lang=js"
import style0 from "./AddAnonymous.vue?vue&type=style&index=0&id=2be6c299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6c299",
  null
  
)

export default component.exports